// ════════════════════════════════════════════════════════════════════════
//  MI PERFIL — llamadas al backend (backend/app/routes/account.py)
//
//  Cambiar contraseña devuelve un token NUEVO: el anterior deja de valer en el
//  mismo instante (así se cierran las demás sesiones). Por eso changePassword
//  lo guarda aquí mismo; si no, la siguiente petición de esta pestaña daría 401
//  y el interceptor de api.js echaría al usuario.
// ════════════════════════════════════════════════════════════════════════
import axios from 'axios';
import API, { authHeader, getStoredUser, saveSession } from './api';

// labelKey/hintKey son claves de traducción (locales/account.js): se traducen al
// pintar, no aquí, para que sigan al idioma elegido.
export const LISTENER_TYPES = [
  { id: 'experto', labelKey: 'account.listener.experto.label', hintKey: 'account.listener.experto.hint', icon: 'sliders' },
  { id: 'melomano', labelKey: 'account.listener.melomano.label', hintKey: 'account.listener.melomano.hint', icon: 'headphones' },
  { id: 'casual', labelKey: 'account.listener.casual.label', hintKey: 'account.listener.casual.hint', icon: 'music' },
];

export async function getProfile() {
  const res = await axios.get(`${API}/account/profile`, { headers: authHeader() });
  return res.data;
}

export async function updateProfile(data) {
  const res = await axios.put(`${API}/account/profile`, data, { headers: authHeader() });
  return res.data;
}

// El tutorial de bienvenida ya se vio (o se saltó): no vuelve a abrirse solo.
export async function markTutorialDone() {
  await axios.post(`${API}/account/tutorial`, null, { headers: authHeader() });
}

export async function changePassword(currentPassword, newPassword) {
  const res = await axios.post(
    `${API}/account/password`,
    { current_password: currentPassword, new_password: newPassword },
    { headers: authHeader() }
  );
  saveSession(res.data.token, getStoredUser());
  return res.data.mensaje;
}

export async function requestEmailChange(currentPassword, newEmail) {
  const res = await axios.post(
    `${API}/account/email`,
    { current_password: currentPassword, new_email: newEmail },
    { headers: authHeader() }
  );
  return res.data.mensaje;
}

export async function confirmEmailChange(token) {
  const res = await axios.post(`${API}/account/email/confirm`, { token });
  return res.data;
}
